import axios from 'axios'
const fieldTemplateUrl = '/api/templates/fields'

export default class FieldTemplateService {
    // Get Field Templates
    static getReportFieldTemplates() {
        return new Promise(async (resolve, reject) => {
            try {
                let results = await axios.get(fieldTemplateUrl)
                resolve(results.data)
            }
            catch (err) {
                reject(err)
            }
        })
    }

    // Get Field Templates
    static getReportFieldTemplateByName(fieldName) {
        return new Promise(async (resolve, reject) => {
            try {
                let fieldUrl = `${fieldTemplateUrl}/${fieldName}`
                let result = await axios.get(fieldUrl)
                resolve(result.data)
            }
            catch (err) {
                reject(err)
            }
        })
    }

    // Create field template
    static createReportFieldTemplate(data) {
        return new Promise(async (resolve, reject) => {
            try {
                let result = await axios.post(fieldTemplateUrl, data)
                resolve(result.data)
            }
            catch (err) {
                reject(err)
            }
        })
    }

    // Update Field template
    static updateFieldTemplate(fieldId, data) {
        return new Promise(async (resolve, reject) => {
            try {
                let fieldUrl = `${fieldTemplateUrl}/${fieldId}`
                let result = await axios.put(fieldUrl, data)
                resolve(result)
            }
            catch (err) {
                reject(err)
            }
        })
    }
}